import { Input, Modal, Spin } from 'antd';
import { Component } from 'react';
import { connect } from 'react-redux';

import { DashingCreditCard, RemoveDashedCreditCard } from '../../../base/utils';
import { Note, Page } from '../../../helbest';
import { API } from '../../../request/api';
import { _edit_user } from '../../../store/actions/login_actions';

class ProfileEdit extends Component {
  constructor({ Login }) {
    super({ Login });
    this._Save = this._Save.bind(this);
    this.state = {
      loading: false,
      phone_number: Login.user.phone_number,
      first_name: Login.first_name,
      last_name: Login.last_name,
      nid: Login.user.national_id,
      credit_card: '',
      cc_edit: true,
      cc_check: false,
      ni_validation: Login.user.ni_validation,
      hide_popup_profile: true,
      naghsh_code: '',
      is_naghsh_code_disabled: false
    };
    this.check_user();
  }

  componentDidMount() {
    this.setState({ loading: true });
    API.get
      .editProfile()
      .then((response) => {
        if (response.success) {
          this.setState({
            nid: response.data.national_id || '',
            credit_card: response.data.credit_card || '',
            naghsh_code: response.data.naghsh_code || '',
            loading: false,
            cc_edit: !response.data.credit_card || response.data.credit_card.length !== 16,
            ni_validation: response.data.ni_validation || false,
            is_naghsh_code_disabled: !!response.data.naghsh_code
          });
        } else {
          this.setState({ loading: false });
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.error('Error : ', error);
      });
  }

  check_user() {
    const { Login, history } = this.props;
    if (!Login.is_login) {
      history.push('/');
    }
  }

  _Save() {
    const {
      naghsh_code,
      credit_card,
      cc_edit,
      cc_check,
      nid,
      first_name,
      last_name,
      phone_number,
      ni_validation
    } = this.state;
    const { dispatch, history } = this.props;

    if (credit_card.length >= 1 && cc_edit && !cc_check) {
      this.setState({ cc_check: true });
    } else if (!credit_card || !cc_edit || cc_check) {
      this.setState({ loading: true });

      API.put
        .putEditProfile(
          phone_number,
          first_name,
          last_name,
          nid,
          credit_card,
          naghsh_code,
          ni_validation
        )
        .then((response) => {
          if (response.success) {
            Note.success(response.message);
            dispatch(
              _edit_user({
                first_name: response.data.first_name,
                last_name: response.data.last_name,
                ni_validation: response.data.ni_validation
              })
            );
            this.setState({ loading: false, cc_check: false });
            history.push('/profile/');
          } else {
            this.setState({ loading: false, cc_check: false });
            Note.error(response.message);
          }
          return response;
        })
        .catch((error) => {
          this.setState({ loading: false, cc_check: false });
          console.error('Error : ', error);
        });
    }
  }

  render() {
    const {
      credit_card,
      naghsh_code,
      cc_edit,
      cc_check,
      loading,
      first_name,
      last_name,
      hide_popup_profile,
      ni_validation,
      nid,
      is_naghsh_code_disabled
    } = this.state;
    return (
      <Page
        address="/profile/"
        back={true}
        className="page-profile"
        logo
        showFooter
        title="اصلاح اطلاعات">
        <div className="container desktop-mode">
          {loading ? (
            <div className="text-center">
              <Spin className="red mt-2" size="large" />
            </div>
          ) : null}

          <form className="profile-edit-form mar-10" onSubmit={(e) => e.preventDefault()}>
            <label className="profile-edit-label"> نام </label>
            <Input
              className="profile-edit-select"
              onChange={(e) => this.setState({ first_name: e.target.value })}
              placeholder="نام خود را وارد کنید"
              type="text"
              value={first_name}
            />

            <label className="profile-edit-label">نام خانوادگی</label>
            <Input
              className="profile-edit-select"
              onChange={(e) => this.setState({ last_name: e.target.value })}
              placeholder="نام خانوادگی خود را وارد کنید"
              type="text"
              value={last_name}
            />

            <label className="profile-edit-label"> کد ملی </label>
            <Input
              className="profile-edit-select"
              disabled={ni_validation === true}
              id="elmt_profile_edit_nationalId_input"
              inputMode="numeric"
              onChange={(e) => {
                this.setState({ nid: e.target.value });
              }}
              pattern="[0-9]*"
              placeholder="کد ملی خود را وارد کنید"
              type="text"
              value={nid}
            />

            <label className="profile-edit-label"> شماره کارت </label>
            <Input
              className="profile-edit-select credit-card-input mar-b-5"
              disabled={!cc_edit}
              inputMode="numeric"
              onChange={(e) =>
                e.target.value.length <= 19
                  ? this.setState({
                      credit_card: RemoveDashedCreditCard(e.target.value)
                    })
                  : null
              }
              pattern="[0-9]*"
              placeholder="شماره کارت خود را وارد کنید"
              type="text"
              value={DashingCreditCard(credit_card)}
            />

            <p>شماره کارت بانکی با نام خریدار کالا تنها برای عودت دادن مبلغ سفارش استفاده میشود.</p>

            <label className="profile-edit-label"> کد نقش </label>
            <Input
              className="profile-edit-select mar-b-5"
              disabled={is_naghsh_code_disabled}
              inputMode="numeric"
              onChange={(e) =>
                e.target.value.length <= 20
                  ? this.setState({
                      naghsh_code: e.target.value
                    })
                  : null
              }
              pattern="[0-9]*"
              type="text"
              value={naghsh_code}
            />

            <div className="text-left">
              <button className="success-btn-profile" onClick={() => this._Save()} type="submit">
                ثبت اطلاعات
              </button>
            </div>
          </form>
        </div>
        <Modal
          centered={true}
          closable={false}
          footer={false}
          onCancel={() => this.setState({ cc_check: false })}
          onOk={this._Save}
          title=""
          visible={cc_check}>
          <div className="profile-edit-modal-check">
            <div className="profile-edit-modal-header" style={{ textAlign: 'center' }}>
              آیا شماره کارت زیر را تائید می‌کنید؟
              <p>{DashingCreditCard(credit_card)}</p>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '20px'
              }}>
              <div
                onClick={this._Save}
                style={{
                  color: 'white',
                  textAlign: 'center',
                  fontSize: ' 12px',
                  padding: ' 8px 13px',
                  width: '90px',
                  height: '33px',
                  background: 'green',
                  borderRadius: '10px'
                }}>
                بله
              </div>
              <div
                onClick={() => this.setState({ cc_check: false })}
                style={{
                  color: 'white',
                  textAlign: 'center',
                  fontSize: ' 12px',
                  padding: ' 8px 13px',
                  width: '90px',
                  height: '33px',
                  background: 'red',
                  borderRadius: '10px'
                }}>
                خیر
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          bodyStyle={{
            padding: 15
          }}
          centered={true}
          className="national-id-popup"
          closable={false}
          footer={false}
          onCancel={() => this.setState({ hide_popup_profile: false })}
          title=""
          visible={hide_popup_profile}>
          <div
            className="update-modal"
            id="elmt_profile_edit_nationlIdAndPhoneNumberSimilarity_modal">
            <p style={{ fontSize: '18px !important' }}>
              شماره موبایل و کد ملی باید متعلق به یک شخص باشد.
            </p>
            <div className="text-center mar-t-15 update-button-container">
              <button
                className="button flex-i center-content btn-h40 btn btn-red  line-none btn-round  pad-10"
                onClick={() => this.setState({ hide_popup_profile: false })}
                type="button">
                متوجه شدم
              </button>
            </div>
          </div>
        </Modal>
      </Page>
    );
  }
}

const mstp = (state) => ({
  Login: state.Login
});
export default connect(mstp)(ProfileEdit);
